(function ($) {

	jQuery(document).ready(function () {
		slideCustomProductTabs();
		switchProductVariationPrice();
		switchVariationProductData();
		changeDisabledButtonText($('.woocommerce-variation-add-to-cart .coala-add-to-cart-button').text());
		changeDisabledButtonText($('.woocommerce-bundle-add-to-cart .woocommerce-bundle-add-to-cart-button').text());
		scrollToVariations();
		scrollToBundle();
		switchButtonBundleOnOptions();
		stickAddToCartButton();
		showReviewForm();
		showFullReview();
		loadMoreReviews();

		wooCommerceRelatedCarousel();
	});

	function wooCommerceRelatedCarousel() {
		if (jQuery('.related-products-carousel-wrapper').length) {
			console.log('related-products-carousel-wrapper')
			const related = new Swiper('.related-products-carousel-wrapper', {
				// Optional parameters
				loop: true,
				slidesPerView: 'auto',
				spaceBetween: 0,
				watchOverflow: false,
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				navigation: {
					nextEl: '#products-carousel-nav-next',
					prevEl: '#products-carousel-nav-prev'
				}
			});
		}
	}

	function slideCustomProductTabs() {
		const faqButton = $('.sliding-tabs-list__title-wrapper');

		faqButton.first().addClass('current-tab').next().slideToggle(300);
		faqButton.first().find('.switch-faq-button').text('-');
		faqButton.each(function () {
			$(this).on('click', function () {
				const question = $(this);
				const switchFaqButton = question.find('.switch-faq-button');
				const isCurrentTab = question.hasClass('current-tab');

				if (isCurrentTab) {
					productTabs(faqButton, true);
					question.next().slideToggle(300);
				} else {
					productTabs(faqButton, false);
					question.next().slideToggle(300);
					question.addClass('current-tab');
					switchFaqButton.text('-');
				}
			});
		});
	}


	function productTabs(faqButton, isCurrentTab) {
		faqButton.each(function () {
			if ($(this).hasClass('current-tab')) {
				if (!isCurrentTab) {
					$(this).next().slideToggle(300);
				}
				$(this).removeClass('current-tab');
				$(this).find('.switch-faq-button').text('+');
			}
			;
		});
	}


	// Display currently selected variation price instead of price range
	function switchProductVariationPrice() {
		const singleVariation = $('.single_variation');
		if (singleVariation.length > 0) {
			const priceRange = $('p.price');
			const priceRangeHtml = priceRange.html();
			$('form.cart').on('show_variation', function (event, data) {
				console.log(data);
				if (data.price_html) {
					priceRange.html(data.price_html);
					priceRange.find('.stock').remove();
					priceRange.append(data.availability_html);
					$('.custom-variation-message').text("");
					const status = $('.title-price-wrapper .price').children('.stock').text();
					if (status != productData.stockStatus) {
						$('.variations_button').removeClass('variations_button--disabled');
					} else {
						$('.variations_button').addClass('variations_button--disabled');
					}
				} else {
					priceRange.find('.stock').remove();
					priceRange.append(data.availability_html);
					$('.custom-variation-message').text("");
					const status = $('.title-price-wrapper .price').children('.stock').text();
					if (status != productData.stockStatus) {
						$('.variations_button').removeClass('variations_button--disabled');
					} else {
						$('.variations_button').addClass('variations_button--disabled');
					}
				}
			}).on('hide_variation', function (event) {
				priceRange.html(priceRangeHtml);
				$('.custom-variation-message').text("");
				$('.variations_button').addClass('variations_button--disabled');
			});
		}
	}

	/* Change product variation data  */
	function switchVariationProductData() {
		const buttonText = $('.woocommerce-variation-add-to-cart .coala-add-to-cart-button').text();
		$('form.cart').on('show_variation', function (event, data) {
			const variationID = data.variation_id;
			const sku = data.sku;
			const value = data.display_price;
			$('.coala-add-to-cart-button').attr('data-product_id', variationID);
			$('.coala-add-to-cart-button').attr('data-product_sku', sku);
			$('.coala-add-to-cart-button').attr('data-product_value', value);

			/** omnibus addon **/
			$('.omnibus-info-variable').addClass('hide');
			$('.omnibus-info-variable[data-variable-id="'+variationID+'"]').removeClass('hide');

			changeDisabledButtonText(buttonText);
		}).on('hide_variation', function (event) {
			changeDisabledButtonText(scriptData.variationDisabledButtonText);
		});
	}

	function changeDisabledButtonText(buttonText) {
		console.log(buttonText);
		const variableProductButton = $('.woocommerce-variation-add-to-cart');
		const bundleProductButton = $('.woocommerce-bundle-add-to-cart');
		if (variableProductButton.length > 0) {
			const buttonLink = variableProductButton.find('.coala-add-to-cart-button');
			if (variableProductButton.hasClass('woocommerce-variation-add-to-cart-disabled')) {
				buttonLink.text(scriptData.variationDisabledButtonText);
			} else {
				buttonLink.text(buttonText);
			}
		}
		if (bundleProductButton.length > 0) {
			const buttonLink = bundleProductButton.find('.bundle-add-to-cart-button');
			if (buttonLink.hasClass('woocommerce-bundle-add-to-cart-disabled')) {
				buttonLink.html(scriptData.bundleDisabledButtonText);
			} else {
				buttonLink.html(buttonText);
			}
		}
	}

	function switchAddToCartButtonClass(productCartButton, buttonPosition, buttonHeight, scrollPosition, windowHeight) {
		if (buttonPosition + buttonHeight < scrollPosition + windowHeight) {
			productCartButton.removeClass('product-cart-button--sticky');
		} else {
			if (!productCartButton.hasClass('product-cart-button--sticky')) {
				productCartButton.addClass('product-cart-button--sticky');
			}
		}
	}

	function stickAddToCartButton() {
		if(jQuery('.product-cart-button').length){
			const productCartButton = $('.product-cart-button');
			const buttonPosition = productCartButton.offset().top;
			const buttonHeight = productCartButton.innerHeight();
			let scrollPosition = $(window).scrollTop();
			let windowHeight = $(window).innerHeight();

			switchAddToCartButtonClass(productCartButton, buttonPosition, buttonHeight, scrollPosition, windowHeight);

			$(window).on('scroll', function () {
				scrollPosition = $(this).scrollTop();
				windowHeight = $(this).innerHeight();

				switchAddToCartButtonClass(productCartButton, buttonPosition, buttonHeight, scrollPosition, windowHeight);
			});
		}
	}


	function showReviewForm() {
		const reviewForm = $('#review_form_wrapper');
		if (reviewForm.length > 0) {
			const reviewButton = $('.review-button');
			const starsIcons = $('.woocommerce-product-rating');
			reviewButton.add(starsIcons).on('click', function () {
				reviewForm.removeClass('review-form-wrapper--hidden');
				$('html, body').animate({
					scrollTop: reviewForm.offset().top - 50     // substract menu height (rounded)
				}, 700);
			});
		}
	}


	function showFullReview() {
		const readMoreButton = $('.read-more-review');
		if (readMoreButton.length > 0) {
			readMoreButton.on('click', function () {
				const fullText = $(this).siblings('.review-full-text');
				const dots = $(this).siblings('.read-more-dots');
				$(this).addClass('read-more-review--hidden');
				fullText.addClass('review-full-text--visible');
				dots.addClass('read-more-dots--hidden');
			});
		}
	}


	function scrollToVariations() {
		const disabledButton = $('.variations_button');
		disabledButton.on('click', function () {
			if (disabledButton.hasClass('variations_button--disabled')) {
				let alertMessage = productData.alertMessage;
				const messageContainer = $('.custom-variation-message');
				const messageContainerPosition = messageContainer.offset().top;
				const stockStatus = $('.title-price-wrapper .price').children('.stock').text();

				if (stockStatus === productData.stockStatus) {
					alertMessage = productData.stockStatus;
				}
				// override default alert function (to disable alert window)
				alert = function () {
				};
				// display message above product variations
				messageContainer.text(alertMessage);
				// scroll to alert message
				if (messageContainerPosition > $(window).innerHeight()) {
					$('html, body').animate({
						scrollTop: messageContainerPosition - 50     // substract menu height (rounded)
					}, 700);
				}
			}
		});
	}

	function scrollToBundle() {
		const disabledButton = $('.bundle_button');
		disabledButton.on('click', function () {
			if (disabledButton.hasClass('bundle_button--disabled')) {
				let alertMessage = productData.alertMessage;
				const messageContainer = $('.custom-variation-message');
				const messageContainerPosition = messageContainer.offset().top;
				const stockStatus = $('.title-price-wrapper .price').children('.stock').text();

				if (stockStatus === productData.stockStatus) {
					alertMessage = productData.stockStatus;
				}
				// override default alert function (to disable alert window)
				alert = function () {
				};
				// display message above product variations
				messageContainer.text(alertMessage);
				// scroll to alert message
				if (messageContainerPosition > $(window).innerHeight()) {
					$('html, body').animate({
						scrollTop: messageContainerPosition - 50     // substract menu height (rounded)
					}, 700);
				}
			}
		});
	}

	function switchButtonBundleOnOptions(){

		const buttonWrapper = $('.yith-wcpb-product-bundled-items');
		if(buttonWrapper.length){
			const min = buttonWrapper.data('min');
			const max = buttonWrapper.data('max');
			//console.log(min);
			//console.log(max);
			buttonWrapper.on('click tap', function(){
				let counter = 0;
				buttonWrapper.find('.in_loop input[type="checkbox"]').each(function(){
					if(jQuery(this).is(':checked')){
						counter++
					}
				});
				//console.log(counter);
				if(min <= counter && counter <= max){
					//console.log('spełnia');
					jQuery('.woocommerce-bundle-add-to-cart').removeClass('bundle_button--disabled');
					jQuery('.woocommerce-bundle-add-to-cart-button').removeClass('woocommerce-bundle-add-to-cart-disabled');
					changeDisabledButtonText(scriptData.bundleButtonText);
					buttonWrapper.find('.in_loop input[type="checkbox"]').each(function(){
						if(!jQuery(this).is(':checked')){
							jQuery(this).attr("disabled", true);
						}
						//console.log('deactivate others');
					});

				} else {
					jQuery('.woocommerce-bundle-add-to-cart').addClass('bundle_button--disabled');
					jQuery('.woocommerce-bundle-add-to-cart-button').addClass('woocommerce-bundle-add-to-cart-disabled');
					changeDisabledButtonText(scriptData.bundleDisabledButtonText);
					buttonWrapper.find('.in_loop.in-stock input[type="checkbox"]').each(function(){
						jQuery(this).attr("disabled", false);
						//console.log('activate all');
					});
				}
			})
		}
	}


	function loadMoreReviews() {
		const loadMoreButton = $('.show-more-reviews');
		if (loadMoreButton.length > 0) {
			const postID = $('.product').attr('id').split('-')[1];
			const current_page = productData.current_comment_page;
			let get_comments_from_page = parseInt(current_page) + 1;
			get_comments_from_page = isNaN(get_comments_from_page) ? 2 : get_comments_from_page;
			loadMoreButton.on('click', function (e) {
				e.preventDefault();
				$.ajax({
					url: scriptData.ajaxUrl,
					method: 'post',
					dataType: 'json',
					data: {
						_ajax_nonce: scriptData.ajaxNonce,
						action: 'load_more_reviews',
						'current_page': get_comments_from_page,
						'per_page': productData.comments_per_page,
						post_ID: postID,
					},
					success: function (response) {
						const comments = response[0];
						const commentsCount = response[1];
						if (comments) {
							let displayedReviewsCount = 0;
							// append new reviews to commentList
							$('.commentlist').append(comments);
							get_comments_from_page += 1;
							// get number of accually displayed reviews
							displayedReviewsCount = $('.commentlist').children().length;
							if (displayedReviewsCount >= commentsCount) {
								loadMoreButton.css({display: 'none'});
							}
						}
					},
					error: function () {
						// console.log('connection error ');
					}
				});
			});
		}
	}


})(jQuery);
